import { Platform } from 'react-native';
import type { Screen, Tab } from '../types';

export type WebRoute =
  | { kind: 'auth'; screen: 'welcome' | 'createAccount' }
  | { kind: 'main'; tab: Tab }
  | { kind: 'detail'; screen: Screen }
  | { kind: 'profile'; handle: string }
  | { kind: 'legal'; doc: 'terms' | 'privacy' | 'cookies' };

export type AppNavigationSnapshot = {
  screen: Screen;
  tab: Tab;
  profileHandle?: string | null;
};

const LEGAL_SCREEN: Record<'terms' | 'privacy' | 'cookies', Screen> = {
  terms: 'legalTerms',
  privacy: 'legalPrivacy',
  cookies: 'legalCookies',
};

const PLAY_TAB_SCREENS: Screen[] = ['findMatch', 'selectCourse', 'scoreInput', 'matchplaySetup'];

function tabForScreen(screen: Screen): Tab {
  return PLAY_TAB_SCREENS.includes(screen) ? 'play' : 'home';
}

export function loggedOutEntryScreen(): Screen {
  return Platform.OS === 'web' ? 'landing' : 'welcome';
}

export function userProfilePath(handle?: string | null, currentPath = '/') {
  if (handle) {
    return `/@${encodeURIComponent(handle)}`;
  }
  if (currentPath.startsWith('/@') && currentPath.length > 2) {
    return currentPath;
  }
  return '/user-profile';
}

export function applyWebRoute(route: WebRoute, hasToken: boolean): AppNavigationSnapshot {
  if (route.kind === 'legal') {
    return { screen: LEGAL_SCREEN[route.doc], tab: 'home' };
  }

  if (route.kind === 'profile') {
    if (!hasToken) {
      return { screen: 'welcome', tab: 'home' };
    }
    return { screen: 'userProfile', tab: 'home' };
  }

  if (route.kind === 'auth') {
    if (hasToken) {
      return { screen: 'main', tab: 'home' };
    }
    return { screen: route.screen, tab: 'home' };
  }

  if (!hasToken) {
    if (route.kind === 'main' && route.tab === 'home') {
      return { screen: 'landing', tab: 'home' };
    }
    return { screen: 'landing', tab: 'home' };
  }

  if (route.kind === 'main') {
    if (route.tab === 'play') {
      return { screen: 'findMatch', tab: 'play' };
    }
    return { screen: 'main', tab: route.tab };
  }
  return { screen: route.screen, tab: tabForScreen(route.screen) };
}
